import * as React from 'react';
import { UIHeading4 } from '@cian/ui-kit';
import * as styles from './SeoSubtitles.css';
import { MapButton } from '../MapButton';

interface ISeoSubtitlesProps {
  subtitle?: string;
  mapFullUrl?: string;
  quickLinks?: React.ReactNode;
}
export const SeoSubtitles: React.FC<ISeoSubtitlesProps> = ({ mapFullUrl, subtitle, quickLinks }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['subtitles']}>
        {subtitle && <UIHeading4 data-testid="Subtitle">{subtitle}</UIHeading4>}
        {quickLinks}
      </div>
      {mapFullUrl && <MapButton mapFullUrl={mapFullUrl} />}
    </div>
  );
};
